module.exports = __webpack_public_path__ + "img/logo-h.2895f26e.png";